export default RAILS_ASSET_URL("/gallery-image-02.webp")
